<template>
  <layout :tituloPagina="`Network | Routers | Edición | ${router.nombre} | History`">
    <div class="row">
      <div class="col-md-12">       
        <div class="card">
          <div class="card-header justify-content-between d-flex align-items-center">
            <h4 class="card-title text-truncate w-100">
              History del router {{ router.nombre }}
            </h4>
            <div class="me-2">
              <a href="#" onclick="return false;" title="Resfrecar history" @click="refrescarHistoryRouter()">
                <i class="mdi mdi-refresh text-success"></i>
              </a>
            </div>
            <div>
              <a href="#" onclick="return false;" @click="cerrar()">
                <i class="mdi mdi-close text-dark"></i>
              </a>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive" style="height: 620px">
              <table class="table table-hover table-nowrap align-middle" id="tabla-history">
                <thead>
                  <tr>
                    <th></th>
                    <th>Time</th>
                    <th>Action</th>
                    <th>Trace</th>
                    <th>Redo</th>
                    <th>Undo</th>
                    <th>By</th>
                    <th>Policy</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="history in historys" :key="history.id">
                    <td>
                      <span :title="armarTitulo(history)">
                        <strong>{{ armarEstado(history) }}</strong>
                      </span>
                    </td>
                    <td>{{ formatoFecha(history.time) }}</td>
                    <td>{{ history.action }}</td>
                    <td :title="history.trace">
                      <p class="text-truncate">
                        {{ history.trace }}
                      </p>
                    </td>
                    <td :title="history.redo">
                      <p class="text-truncate">
                        {{ history.redo }}
                      </p>
                    </td>
                    <td :title="history.undo">
                      <p class="text-truncate">
                        {{ history.undo }}
                      </p>
                    </td>
                    <td>{{ formatoPalabra(history.by) }}</td>
                    <td>{{ formatoPalabra(history.policy) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="text-right">
          <button class="btn btn-secondary" @click="atras()">
            <i class="mdi mdi-chevron-left"></i>
            Atrás
          </button>
          <button class="btn btn-success ms-1" @click="refrescarHistoryRouter()">
            <i class="mdi mdi-refresh"></i>
            Refrescar
          </button>
        </div>
      </div>
    </div>
    <br>
  </layout>
</template>

<script>
import Layout from "@/views/layouts/main"
import RouterSrv from '@/services/RouterSrv.js'
import moment from 'moment'

export default {
  name: 'historyRouter',
  components: { Layout },
  data() {
    return {
      id_router: null,
      router: { 
        id: null,
        nombre: ''
      },
      historys: [],
      mostrar_spinner: true,
      intervals: {
        actualizacion: null
      },
    }
  },

  created: function() {
    var self = this

    self.id_router = self.$route.params.id
    self.cargarRouter()

    self.intervals.actualizacion = setInterval(function() {
      self.mostrar_spinner = false
      self.refrescarHistoryRouter()
    }, 60000)
  },
  beforeUnmount() {
    clearInterval(this.intervals.actualizacion)
  },
  methods: {
    atras: function() {
      this.$router.go(-1)
    },

    armarEstado: function(history) {
      var self = this, estado = ''

      if (self.toBoolean(history.undoable))  estado += 'U'

      return estado
    },

    armarTitulo: function(history) {
      var self = this, partes = []

      if (self.toBoolean(history.undoable)) partes.push('U - Undoable')

      return partes.join(', ');
    },
    cerrar: function() {
      var self = this
      self.atras()
    },
    cargarRouter: function() {
      var self = this
      self.id_router = self.$route.params.id

      RouterSrv.routerJSON(self.id_router).then(response => {
        self.router = response.data

        self.refrescarHistoryRouter()
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = ''
        }
        mensaje != '' ? iu.msg.error(mensaje) : ''
        console.log(error)
      })
    },
    formatoFecha(fecha, formatoFecha = 'YYYY-MM-DD HH:mm:ss', formatoConvertir = 'DD/MM/YYYY HH:mm:ss') {
      return moment(fecha, formatoFecha).locale('es-mx').format(formatoConvertir)
    },
    formatoPalabra: function(palabra) {
      return palabra[0].toUpperCase() + palabra.slice(1);
    },
    toBoolean: function(value) {
      return value === true || value === 1 || value === '1' ||
            String(value).toLowerCase() === 'true' ||
            String(value).toLowerCase() === 'on' ||
            String(value).toLowerCase() === 'yes'
    },
    refrescarHistoryRouter: function() {
      var self = this
      
      if(self.mostrar_spinner) iu.spinner.mostrar("#tabla-history")

      RouterSrv.historyJSON(self.id_router).then(response => {
        self.historys = response.data
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudo cargar los history'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        if(self.mostrar_spinner) iu.spinner.ocultar("#tabla-history")
        self.mostrar_spinner = true
      })
    }
  }
}
</script>

<style scoped>
.text-truncate {
  width: 250px;
}
</style>